import * as React from 'react';
import { Route } from 'react-router';
import isNode from '@reverbdotcom/commons/dist/is-node';
import { FollowListActions } from '../components/discovery/feed/follow_list_store';
import UserStore from '../reverb-js-common/user_store';

const path = 'my/feed/customize';

function fetchFollows() {
  if (isNode) { return; }

  if (UserStore.getState().loggedOut) {
    return;
  }

  FollowListActions.fetch();
}

const FeedCustomizationRoute = (
  <Route
    key={path}
    path={path}
    props={{ clientSide: true }}
    getComponent={(_location, cb) => {
      require.ensure(
        [],
        (require) => {
          cb(null, require('../components/discovery/feed/customization_container').default);
        },
        'feed',
      );
    }}
    onChange={() => {
      fetchFollows();
    }}
    onEnter={() => {
      fetchFollows();
    }}
  />
);

export default FeedCustomizationRoute;
